import { Field } from 'redux-form';
import { FormAutocompleteField, FormNumberField } from '../../../components/fields';
import uniqBy from 'lodash/uniqBy';
import React from 'react';

export default function Flight(props) {

  return (
    <>
      <Field
        label="Airline"
        component={FormAutocompleteField}
        name="routePoints[0].airport.flight.airline"
        options={uniqBy(props.airlines, 'name')}
        getOptionLabel={(option) => option?.name || ''}
      />

      <Field
        label="Flight number"
        component={FormNumberField}
        name="routePoints[0].airport.flight.number"
      />
      <Field
        label="Meeting Area"
        component={FormAutocompleteField}
        name="routePoints[0].airport.flight.meetingArea"
        options={[ 'inside', 'outside' ]}
      />
    </>
  );
}
